import React, { FC } from 'react';

import { Box } from '@lucid/components-react';
import { useInView } from 'react-intersection-observer';
import Lottie from 'lottie-react';

interface VisibleLottieProps {
  /** Allows the component to get additional styles. */
  className?: string;
  threshold?: number;
  /** The path the lottie animation JSON file. */
  path?: string;
  /** The lottie animation JSON data. */
  data?: string;
}

const VisibleLottie: FC<VisibleLottieProps> = ({ className, threshold = 0.5, path, data }) => {
  const [ref] = useInView({ threshold });

  const animationObject: {
    loop: boolean;
    animationData: any;
    rendererSettings: any
  } = {
    animationData: '',
    loop: false,
    rendererSettings: {
      filterSize: {
        width: '200%',
        height: '200%',
        x: '-50%',
        y: '-50%',
      }
    }
  };

  if (data) {
    animationObject.animationData = JSON.parse(data);
  } else if (path) {
    animationObject.animationData = path;
  }

  return (
    <Box ref={ref} className={className}>
      <Lottie {...animationObject} />
    </Box>
  );
};

export { VisibleLottie };
export default VisibleLottie;
